// components/AccordionItem.jsx
import React, { useState, useEffect } from 'react';
import './AccordionItem.css';

const AccordionItem = ({ title, children, summary, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);

  return (
    <div className="accordion-item">
      <button
        className="accordion-header"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span>{title}</span>
        <span className="arrow">{isOpen ? '▲' : '▼'}</span>
      </button>

      {!isOpen && summary && (
        <div className="accordion-summary">
          {summary.length > 250 ? summary.slice(0, 247) + '...' : summary}
        </div>
      )}

      {isOpen && <div className="accordion-content">{children}</div>}
    </div>
  );
};

export default AccordionItem;
